<template>
  <transition name="fade">
    <div
      v-show="open"
      class="drawer"
      role="menu"
    >
      <transition name="slide">
        <div
          v-show="open"
          class="menu"
        >
          <ul class="menu-items">
            <li
              v-if="isEmployee"
              class="menu-item"
            >
              <router-link
                to="/build-types"
                class="menu-item-link"
                @click="toggleDrawer"
              >
                Build Types
              </router-link>
            </li>
            <li
              v-if="isEmployee"
              class="menu-item"
            >
              <router-link
                to="/calibers"
                class="menu-item-link"
                @click="toggleDrawer"
              >
                Calibers
              </router-link>
            </li>
            <li
              v-if="isEmployee"
              class="menu-item"
            >
              <router-link
                to="/customers"
                class="menu-item-link"
                @click="toggleDrawer"
              >
                Customers
              </router-link>
            </li>
            <li
              v-if="isEmployee"
              class="menu-item"
            >
              <router-link
                to="/dashboard"
                class="menu-item-link"
                @click="toggleDrawer"
              >
                Dashboard
              </router-link>
            </li>
            <li
              v-if="isEmployee"
              class="menu-item"
            >
              <router-link
                to="/inventory"
                class="menu-item-link"
                @click="toggleDrawer"
              >
                Inventory
              </router-link>
            </li>
            <li
              v-if="isEmployee"
              class="menu-item"
            >
              <router-link
                to="/inventory-types"
                class="menu-item-link"
                @click="toggleDrawer"
              >
                Inventory Types
              </router-link>
            </li>
            <li
              v-if="isEmployee"
              class="menu-item"
            >
              <router-link
                to="/manufacturers"
                class="menu-item-link"
                @click="toggleDrawer"
              >
                Manufacturers
              </router-link>
            </li>
            <li
              v-if="isEmployee"
              class="menu-item"
            >
              <router-link
                to="/orders"
                class="menu-item-link"
                @click="toggleDrawer"
              >
                Orders
              </router-link>
            </li>
            <li
              v-if="isEmployee"
              class="menu-item"
            >
              <router-link
                to="/purchase-orders"
                class="menu-item-link"
                @click="toggleDrawer"
              >
                Purchase Orders
              </router-link>
            </li>
            <li
              v-if="isEmployee"
              class="menu-item"
            >
              <router-link
                to="/quotes"
                class="menu-item-link"
                @click="toggleDrawer"
              >
                Quotes
              </router-link>
            </li>
            <li
              v-if="isEmployee"
              class="menu-item"
            >
              <router-link
                to="/services"
                class="menu-item-link"
                @click="toggleDrawer"
              >
                Services
              </router-link>
            </li>
            <li
              v-if="isEmployee"
              class="menu-item"
            >
              <router-link
                to="/suppliers"
                class="menu-item-link"
                @click="toggleDrawer"
              >
                Suppliers
              </router-link>
            </li>
            <li
              v-if="isEmployee"
              class="menu-item"
            >
              <router-link
                to="/users"
                class="menu-item-link"
                @click="toggleDrawer"
              >
                Users
              </router-link>
            </li>
            <li
              v-if="!isEmployee"
              class="menu-item"
            >
              <router-link
                to="/my-orders"
                class="menu-item-link"
                @click="toggleDrawer"
              >
                My Orders
              </router-link>
            </li>
            <li
              v-if="!isEmployee"
              class="menu-item"
            >
              <router-link
                to="/my-quotes"
                class="menu-item-link"
                @click="toggleDrawer"
              >
                My Quotes
              </router-link>
            </li>
          </ul>
        </div>
      </transition>
      <div
        v-show="open"
        class="overlay"
        @click="toggleDrawer"
      />
    </div>
  </transition>
</template>

<script lang="ts">
import { LOCAL_STORAGE_CONSTANTS } from '@/constants/localstorage.contstants'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LeftDrawer',
  props: {
    drawerOpen: {
      type: Boolean,
      required: true
    }
  },
  emits: ['toggled'],
  data() {
    const isEmployeeFlag = localStorage.getItem(LOCAL_STORAGE_CONSTANTS.isEmployee)
    const isEmployee = isEmployeeFlag !== null && isEmployeeFlag === 'true'

    return {
      isEmployee,
      open: false
    }
  },
  watch: {
    drawerOpen(): void {
      this.toggleDrawer()
    }
  },
  mounted() {
    window.addEventListener(LOCAL_STORAGE_CONSTANTS.eventName, this.onLocalStorageChanged)
  },
  unmounted() {
    window.removeEventListener(LOCAL_STORAGE_CONSTANTS.eventName, this.onLocalStorageChanged)
  },
  methods: {
    onLocalStorageChanged(): void {
      const isEmployeeFlag = localStorage.getItem(LOCAL_STORAGE_CONSTANTS.isEmployee)
      this.isEmployee = isEmployeeFlag !== null && isEmployeeFlag === 'true'
    },
    toggleDrawer(): void {
      this.open = !this.open
      this.$emit('toggled', this.open)
    }
  }
})
</script>

<style scoped lang="scss">

.drawer {
  position: fixed;
  display: flex;
  height: calc(100% - 94px);
  width: 100%;
  top: 94px;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);

  @include desktop {
    display: none;
  }


  > .menu {
    width: 300px;
    z-index: 500;
    background-color: $Color-fill-gray;
    overflow-y: auto;
    box-shadow: inset 0 2px 4px 0 #00000033;
    -ms-box-shadow: inset 0 2px 4px 0 #00000033;
    -webkit-box-shadow: inset 0 2px 4px 0 #00000033;
  
    > .menu-items {
      background-color: $Color-white;
      padding: 0;
      margin: 4px 0 0 0;
      width: 100%;
      list-style-type: none;

      > .menu-item {
        border-bottom: 2px solid $Color-fill-gray;
        line-height: 48px;

        &:hover {
          background-color: #f8be9d;
        }

        > .menu-item-link {
          display: block;
          margin-left: 25px;
          text-decoration: none;
          color: $Color-font-high;
          font-size: 14px;
          height: 100%;

          &.router-link-exact-active {
            color: $Color-sac-orange;
          }

          &:hover {
            font-weight: bold;
          }
        }
      }
    }
  }

  > .overlay {
    @include desktop {
      display: none;
    }

    z-index: 500;
    cursor: pointer;
  }
}

.fade {
  &-enter-active, &-leave-active {
    transition: opacity 0.5s ease;
  }

  &-enter-from, &-leave-to {
    opacity: 0;
  }
}

.slide {
  &-enter-from {
    transform: translateX(-300px);
  }

  &-leave-from {
    transform: translateX(0);
  }

  &-enter-active {
    transition : all 0.5s ease-in-out;
  }

  &-leave-active {
    transition: all 0.5s ease-in-out;
  }

  &-enter-to {
    transform: translateX(0);
  }

  &-leave-to {
    transform: translateX(-300px);
  }
}
</style>
